<template>
    <div>
      <div v-show="isShowDialog">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
          <div class="weui-dialog__hd"><strong class="weui-dialog__title">{{dialogTitle}}</strong></div>
          <div class="weui-dialog__bd">{{dialogContent}}</div>
          <div class="weui-dialog__ft">
            <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="confirm">确定</a>
          </div>
        </div>
      </div>
    </div>
</template>
<style>
</style>
<script>
  export default{
    name: 'we-dialog',

    methods: {
      confirm () {
        this.$store.commit('setIsShowDialog', {
          isShowDialog: false
        })
      }
    },

    computed: {
      isShowDialog () {
        return this.$store.getters.getIsShowDialog
      },

      dialogTitle () {
        return this.$store.getters.getDialogTitle
      },

      dialogContent () {
        return this.$store.getters.getDialogContent
      }
    }
  }
</script>



// WEBPACK FOOTER //
// WeDialog.vue?3bc68205